// extracted by mini-css-extract-plugin
export default {"badge":"BadgeStatus_badge__fbVyV"};